import { useNavigate } from "react-router";
import Arrow from "../../assets/svg/arrow.svg";
import Download from "../../assets/svg/download.svg";
import Filter from "../../assets/svg/filter.svg";
import { useCallback, useEffect, useState } from "react";
import { DashboardSearchIcon } from "../resources/assetsManager";
import {
  PRIMARY_COLOR,
  SIDEBAR_COLOR,
  WHITE_COLOR,
} from "../resources/colorsManager";
import { CustomInput } from "./customInput/CustomInput";
import { useRef } from "react";
import { IoRefreshSharp } from "react-icons/io5";
const TopHeaderComponent = ({
  width,
  headerName,
  onClickFilter,
  onClickDownload,
  showDownload = true,
  showFilter = true,
  showDeveloper,
  isSearchRequired,
  inputStyle,
  placeholder,
  disableDownloadIcon = false,
  textStyle,
  onClickBack,
  isOnClickBack = false,
  onSearchStart,
  validator = "",
  onClickRefresh,
  isRefreshRequired = false,
}) => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const ref = useRef(null);

  let timer;
  const debounce = (val) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      onSearchStart(val);
    }, 1000);
  };

  const optimizedFn = useCallback(debounce, []);

  return (
    <div
      style={{
        backgroundColor: WHITE_COLOR,
        width: width,
        height: "15%",
        borderRadius: "20px",
        color: "black",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        minHeight: "70px",
        maxHeight: "75px",
        overflow: "scroll",
      }}
      ref={ref}
    >
      <div
        style={{
          display: "flex",
          marginLeft: "20px",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => {
          if (isOnClickBack) {
            onClickBack();
          } else navigate("/dashboard");
        }}
      >
        <img
          src={Arrow}
          style={{ width: 20, height: 20, marginRight: "15px" }}
          onClick={() => {
            if (isOnClickBack) {
              onClickBack();
            } else navigate("/dashboard");
          }}
          alt="back"
        />
        <p
          style={{
            margin: "0px 20px 0px 5px",
            fontSize: "20px",
            color: "black",
            whiteSpace: "nowrap",
            ...textStyle,
          }}
          className="roboto"
        >
          {headerName}
        </p>
      </div>
      <div
        style={{
          marginRight: "30px",
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
        }}
      >
        {isRefreshRequired && (
          <IoRefreshSharp
            size={25}
            color="dodgerblue"
            style={{
              marginRight: 20,
              cursor: "pointer",
            }}
            onClick={onClickRefresh}
            title="Refresh"
          />
        )}
        {showDownload && (
          <img
            src={Download}
            style={{
              width: 25,
              height: 25,
              marginRight: "30px",
              cursor: "pointer",
            }}
            alt="Download"
            onClick={() => onClickFilter()}
          />
        )}

        {showFilter && (
          <img
            src={Filter}
            style={{
              width: 25,
              height: 25,
              cursor: disableDownloadIcon ? "not-allowed" : "pointer",
            }}
            onClick={() => {
              !disableDownloadIcon && onClickDownload();
            }}
            alt="Filter"
            title={disableDownloadIcon && "No data to download"}
          />
        )}

        {isSearchRequired && (
          <div
            style={{
              width: "40%",
              minWidth: "400px",
              border: `1px solid ${SIDEBAR_COLOR}`,
              height: "50px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              padding: "0px 10px",
            }}
          >
            <img src={DashboardSearchIcon} />
            <CustomInput
              type={"input"}
              value={searchValue}
              onChange={(val) => {
                setSearchValue(val);
                optimizedFn(val);
              }}
              placeholder={placeholder}
              inputStyles={{ border: "0px", height: "30px", width: "80%" }}
              validator={validator ? validator : "commonSearch"}
            />
          </div>
        )}

        {showDeveloper && (
          <div
            style={{
              marginRight: 20,
              marginLeft: 20,
            }}
          >
            {showDeveloper}
          </div>
        )}
      </div>
    </div>
  );
};

export default TopHeaderComponent;
